export default __webpack_public_path__ + "static/media/background.94246e71.webp";